<template>
  <div class="chat_container">
    <!-- <div style="width: 4px;"></div> -->
    <itemTalk />
    <div class="ChatPage">
      <div class="header">
        <JwChat-item
          :config="config"
          @addTag="bindAddTag"
          @updateNickname="updateNickAction"
          @updateMarks="updateMarkAction"
        />
        <slot name="header" />
      </div>
      <div class="header_line"></div>
      <div class="chatBox">
        <div class="key_container">
          <div style="display: flex;height: 35px;align-items: center;justify-content: flex-start;width: 100%;">
            <div class="history_div" @click="getHistoryAction" style="margin-left: auto;">
              <img
                class="history_img"
                src="../../static/talks/t_history.png"
                style="width: 16px; height: 16px"
              />
              <label class="history_lb">查看历史消息</label>
            </div>
            <div style="width: 80px;color: #5a9cf8;" @click="showMoreClick">{{ isShowMore? "收起信息":"更多信息" }} <i :class="isShowMore?'el-icon-arrow-up':'el-icon-arrow-down'" style="color: #5a9cf8;"></i></div>
          </div>
          <div style="display: flex;flex-direction: column;align-items: center;justify-content: flex-start;width: 100%;" v-if="isShowMore">
            <div class="query_div">
            <label class="query_lb"   v-if="keyInfo.query !== ''">
              <span>访客搜索：</span>
              <el-popover
                  placement="bottom"
                  class="url_lb"
                  width="300"
                  trigger="hover"
                >
                  <div class="url-allShow">
                    <span class="searchText">{{
                keyInfo && keyInfo.query !== "" ? keyInfo.query : "无"
              }}</span>
                    <span class="url-copy" @click="copyText(keyInfo.query,3)"
                      >点击复制搜索词</span
                    >
                  </div>
                  <label
                  class="searchText"
                    @contextmenu.prevent.stop="copyText(keyInfo.query,3)"
                    slot="reference"
                  >
                  {{
                  keyInfo && keyInfo.query !== "" ? keyInfo.query : "无"
                }}
                  </label>
                </el-popover>
             </label>
            <label class="query_lb"   v-else>
              <span>访客搜索：</span>
              <span class="searchText">无</span></label>

              <label style="display: flex;justify-content: flex-end;align-items: center;margin-right: 1.25rem;" class="query_lb"
               v-if="keyInfo.cid !== ''" >永久编号：
               <el-popover
                  placement="bottom"
                  class="url_lb"
                  width="300"
                  trigger="hover"
                >
                  <div class="url-allShow">
                    <span>
                      {{
                  keyInfo && keyInfo.cid !== "" ? keyInfo.cid : "无"
                }}</span
                    >
                    <span class="url-copy" @click="copyText(keyInfo.cid,2)"
                      >点击复制永久编号</span
                    >
                  </div>
                  <label
                    class="url_lb"
                    @contextmenu.prevent.stop="copyText(keyInfo.cid,2)"
                    slot="reference"
                  >
                  {{
                  keyInfo && keyInfo.cid !== "" ? keyInfo.cid : "无"
                }}
                  </label>
                </el-popover>
              
            </label>
              <label class="query_lb"
               v-else ><span>永久编号：</span>
              <span class="site_lb" style="max-width: 150px;">无</span></label>
          </div>
          <div class="key_div">
            <div class="keyword" style="width: 100%;" v-if="keyInfo.keyword !== ''">
              <!-- {{ keyInfo }} -->
              <!-- keyInfo-------{{ keyInfo && keyInfo }} <br />
              keyInfo.keyword------- {{ keyInfo && keyInfo.keyword }} <br /> -->
              <label class="key_lb"
                style="display: flex;align-items:center;" >关键字：
                <el-popover
                  placement="bottom"
                  class="url_lb"
                  width="300"
                  trigger="hover"
                >
                  <div class="url-allShow">
                    <span>
                      {{
                  keyInfo && keyInfo.keyword !== "" ? keyInfo.keyword : "无"
                }}</span
                    >
                    <span class="url-copy" @click="copyText(keyInfo.keyword,1)"
                      >点击复制关键字</span
                    >
                  </div>
                  <label
                    class="url_lb"
                    @contextmenu.prevent.stop="copyText(keyInfo.keyword,1)"
                    slot="reference"
                  >
                  {{
                  keyInfo && keyInfo.keyword !== "" ? keyInfo.keyword : "无"
                }}
                  </label>
                </el-popover></label>
                <label class="site_lb" style="width: 150px;margin-right: 20px;">渠道：{{ getNameBySource(keyInfo.source) }}
              </label>
            </div>
            <div class="keyword" style="width: 100%;" v-else>
            
              <label class="key_lb"
                style="display: flex;align-items:center;padding-left:0px;" >关键字：无
              </label>
              <label class="site_lb" style="width: 150px;margin-right: 20px;">渠道：{{ getNameBySource(keyInfo.source) }}
              </label>
            </div>
            <div class="otherInfo" v-if="keyInfo.from_url !== ''">
              <label class="brow_lb"
                >当前浏览：
                <el-popover
                  placement="bottom"
                  class="url_lb"
                  width="300"
                  trigger="hover"
                >
                  <div class="url-allShow">
                    <span>
                      {{
                        keyInfo && keyInfo.from_url !== ""
                          ? keyInfo.from_url
                          : "无"
                      }}</span
                    >
                    <span class="url-copy" @click="copyText(keyInfo.from_url,0)"
                      >点击复制链接</span
                    >
                  </div>
                  <label
                    class="url_lb"
                    @contextmenu.prevent.stop="copyText(keyInfo.from_url,0)"
                    slot="reference"
                  >
                    {{
                      keyInfo && keyInfo.from_url !== ""
                        ? keyInfo.from_url
                        : "无"
                    }}
                  </label>
                </el-popover></label>

              <label class="site_lb"
                v-if="!$store.state.isShowIp">所属站点：{{
                  keyInfo && keyInfo.site_name !== "" ? keyInfo.site_name : "无"
                }}
              </label>
              <label class="site_lb"
                v-else>访客ip：{{
                  visitorIp || "无"
                }}
              </label>
            </div>
            <div class="otherInfo" v-else>
              <label class="brow_lb">当前浏览：无 </label>
              <label class="site_lb"
              v-if="!$store.state.isShowIp">所属站点：{{
                  keyInfo && keyInfo.site_name !== "" ? keyInfo.site_name : "无"
                }}
              </label>
              <label class="site_lb"
              v-else>访客ip：{{
                  visitorIp || "无"
                }}
              </label>
            </div>
          </div>

          </div>
        </div>

        <div class="taleBox" ref="scrollNode">
          <chatList
            ref="chatlist"
            :user="userData"
            @getFeedbackState="handleGetFeedbackState"
            :feedback="getFeedback"
            :list="$store.state.selectedChatList"
            @loadHistory="loadHistoryHandler"
            @getDetail="getDetailRequest"
            @updateMark="updateMark"
            @sendList="getSendList"
            :source="0"
            :keyInfo="keyInfo"
          />
        </div>
        <div class="toolBox">
          <div class="header_line"></div>
          <!-- <tools
            ref="bar_tools"
            class="tools"
            @emoji="bindEmoji"
            @clickSend="bindEnter"
            @upImage="uploadImgAction"
            :config="config"
          >
            <slot name="tools" slot="tools" />
          </tools> -->
          <tools
            ref="bar_tools"
            class="tools"
            @emoji="bindEmoji"
            :feedback="getFeedback"
            @endChat="clickEnd"
            :list="$store.state.selectedChatList"
            :user="userData"
            @interpretAction="clickIntrerpret"
            @setAdapter="setAdapterAction"
            @upImage="uploadImgAction"
            @upVideo="uploadVideoAction"
            @sendCard="sendCard"
            :config="config"
          >
            <slot name="tools" slot="tools" />
          </tools>
          <!-- <EnterBox ref="enterBox" @submit="clickEnter" v-model="inputMsg" :textEnble="!isCanEdit"/> -->
          <EnterBox
            ref="enterBox"
            :list="getList"
            :feedback="getFeedback"
            @getFeedbackState2="handleGetFeedbackState2"
            @submit="clickEnter"
            @changeSendMessage="changeSendMessage"
            v-model="inputMsg"
            :config="config"
            :keyInfo="keyInfo"
            :selectedClient="
              $store.state.colleageAngle
                ? $store.state.college.nowSelectClient
                : $store.state.selectedClient
            "
          />
          <bottom-tools
            ref="bottomBox"
            class="bottomBox"
            @isTrust="getTrustVal"
            :switchVal="isCanEdit"
            :config="config"
            @clickSend="bindEnter"
          ></bottom-tools>
          <!-- <bottom-tools
            ref="bottomBox"
            class="bottomBox"
            :user="userData"
            @endChat="clickEnd"
            @interpretAction="clickIntrerpret"
            @setAdapter="setAdapterAction"
            @isTrust="getTrustVal"
            :switchVal="isCanEdit"
          ></bottom-tools> -->
        </div>
      </div>
    </div>

    <el-dialog
      title=""
      class="tag_dialog"
      v-if="isAddTag"
      :visible.sync="isAddTag"
      width="40%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div
        class="common_div"
        v-if="(usedTagList != null) & (usedTagList.length > 0)"
      >
        <label class="tag_lb">常用标签</label>
        <div class="tag_box">
          <!-- <div v-for="(item, index) in usedTagList" :key="index" size="small" @click="chooseTag(0, index)" 
					:style="{'border-color':'#'+item.color, 'color':'#'+item.color}"
					:class="{'tag_btn':!item.selected, 'tag_selected':item.selected}">{{item.name}}</div> -->
          <div
            v-for="(item, index) in usedTagList"
            :key="index"
            size="small"
            @click="chooseTag(0, index)"
          >
            <div class="tag_btn" v-if="!item.selected">{{ item.name }}</div>
            <div
              v-else
              class="tag_selected"
              :style="{
                'border-color': '#' + item.color,
                color: '#' + item.color,
              }"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="all_div">
        <label class="tag_lb">所有标签</label>
        <div class="tag_box">
          <!-- <div v-for="(item, index) in allTagList" :key="index" size="small" @click="chooseTag(1, index)" 
					:style="{'border-color':'#'+item.color, 'color':'#'+item.color}"
					:class="{'tag_btn':!item.selected, 'tag_selected':item.selected}">{{item.name}}</div> -->
          <div
            v-for="(item, index) in allTagList"
            :key="index"
            size="small"
            @click="chooseTag(1, index)"
          >
            <div class="tag_btn" v-if="!item.selected">{{ item.name }}</div>
            <div
              v-else
              class="tag_selected"
              :style="{
                'border-color': '#' + item.color,
                color: '#' + item.color,
              }"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="item_font" @click="isAddTag = false" size="small"
          >取 消</el-button
        >
        <el-button
          class="item_font"
          type="primary"
          @click="setTagAction"
          size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <transter
      v-if="isShowTranster"
      :showDialog="isShowTranster"
      @closeTranster="cancelTranster"
      :serviceList="customList"
      @setCustomer="setTranster"
      :type="transterType"
    ></transter>

    <el-dialog
      title="修改昵称"
      :visible.sync="isShowUpdate"
      width="40%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-input
        v-model="inputNick"
        placeholder="请输入昵称"
        maxlength="30"
        style="width: 60%"
        clearable
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowUpdate = false">取 消</el-button>
        <el-button type="primary" @click="updateNickRequest">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="备注"
      :visible.sync="isShowMark"
      width="40%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-input
        type="textarea"
        v-model="inputMark"
        placeholder="请输入备注"
        style="width: 100%"
        maxlength="40"
        show-word-limit
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowMark = false">取 消</el-button>
        <el-button type="primary" @click="updateMarkRequest">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import itemTalk from "@/components/Chat/itemTalk";
import chatList from "./Chat/chatList.vue";
import tools from "./Chat/tools.vue";
import bottomTools from "./Chat/bottomTools.vue";
import EnterBox from "./Chat/enterBox.vue";
import transter from "./Chat/transter.vue";
import $ from "jquery";
import { sendWebsocket } from "@/utils/websocket.js";

export default {
  name: "homeChat",
  components: {
    itemTalk,
    chatList,
    tools,
    bottomTools,
    EnterBox,
    transter,
  },

  props: ["userInfo", "quickReply"],

  data() {
    return {
      num: 5000,
      inputMsg: "",
      list: [],
      keyInfo: {},

      //header头部数据源
      config: {
        name: "",
        ipdress: "",
        number: "4",
        tags: [],
        source: "0",
        mark: "",
        itype: "0",
        callback: this.bindCover,
        aduserId: "",
        historyConfig: {
          tip: "", //'加载更多',
          callback: this.bindLoadHistory,
        },
        canOperate: "",
      },

      //标签
      userData: this.userInfo,
      isAddTag: false,
      allTagList: [],
      usedTagList: [],
      selectedTagList: [],

      //在线客服
      isShowTranster: false,
      customList: [],

      //分页
      currentPage: 1,
      pageSize: 99,
      totalPage: 0,
      isScolTop: false, //true-向上滚到顶  false-向下滚到底
      // isShowHistory: false,

      isSetAdapter: false,

      //修改昵称
      isShowUpdate: false,
      inputNick: "",

      isShowMark: false,
      inputMark: "",

      transterType: 0,
      isCanEdit: false,
      getFeedback: false,
      getList: [],
      isShowMore:true,
      sourceList: [{
						label: '百度',
						value: 1
					},
					{
						label: '360',
						value: 2
					},
					{
						label: '搜狗',
						value: 3
					},
					{
						label: '神马',
						value: 4
					},
					{
						label: '快手',
						value: 7
					},
					{
						label: '其他',
						value: 0
					},
				],
    };
  },

  computed: {
    visitorIp() {
      return this.util.getVisitorIp(this.keyInfo);
    },
    nowChatList() {
      console.log(
        "homeChat computed nowChatList:",
        this.$store.state.selectedChatList
      );
      return this.$store.state.selectedChatList;
    },

    upDetail() {
      console.log(
        "homeChat computed upDetail = ",
        this.$store.state.toUpDetail
      );
      return this.$store.state.toUpDetail;
    },
    troubleListLen() {
      return this.$store.state.troubleList.length;
    },
    visitor() {
      console.log("quickTalk computed visitor");
      console.log(
        "quickTalk computed visitor ikey = ",
        this.$store.state.selectedKey
      );

      if (this.$store.state.colleageAngle === 4) {
        return this.$store.state.college.nowSelectClient;
      } else {
        return this.$store.state.selectedClient;
      }
    },
    selectedClient() {
      return this.$store.state.selectedClient;
    },
  },

  watch: {
    userInfo(newVal, oldVal) {
      console.log("homeChat watch userinfo new = ", newVal);
      console.log("homeChat watch userinfo old = ", oldVal);

      this.userData = newVal;

      this.$store.state.selectedChatList = null;
      this.currentPage = 1;
      this.getDetailRequest();
    },

    quickReply(newVal, oldVal) {
      console.log("homeChat watch quickReply new = ", newVal);
      console.log("homeChat watch quickReply old = ", oldVal);
      console.log("homeChat watch this.config ", this.config);
      // && this.config.canOperate
      if (newVal !== null ) {
        this.inputMsg = newVal;
        if (newVal) {
          //this.$store.state.newQuickFlag = true;
          if (this.$store.state.colleageAngle) {
            this.$store.state.college.nowSelectClient.inputValue =
              this.inputMsg;
          } else {
            this.$store.state.selectedClient.inputValue = this.inputMsg;
          }
        }
      }
    },

    visitor(newVal, oldVal) {
      console.log("quickTalk watch visitor newVal = ", newVal);
      console.log("quickTalk watch visitor oldVal = ", oldVal);
      if (newVal) {
        this.$emit("changeQuickReply", "");
      }
    },

    upDetail(newVal, oldval) {
      console.log("homeChat watch upDetail newval = ", newVal);
      console.log("homeChat watch upDetail oldVal = ", oldval);

      if (newVal.type === 1) {
        //1：客户昵称 2：客户备注 3：标签列表
        this.config.name = newVal.content;
      } else if (newVal.type === 2) {
        this.config.mark = newVal.content;
      } else if (newVal.type === 3) {
        this.config.tags = newVal.content;
      } else if (newVal.type === 4) {
        var selected = null;
        if (this.$store.state.colleageAngle) {
          selected = this.$store.state.college.nowSelectClient;
        } else {
          selected = this.$store.state.selectedClient;
        }
        // this.config.name = response.data.customerNickname
        if (selected.isUpdateNike === 1) {
          this.config.name = selected.nickname;
        } else {
          if (
            this.util.changeGender(selected.gender) === "" &&
            this.util.nullToString(selected.age) === ""
          ) {
            this.config.name = selected.nickname;
          } else {
            this.config.name =
              this.util.changeGender(selected.gender) +
              this.util.changeAge(selected.age);
          }
        }
      }
    },
    nowChatList: {
      handler(newVal) {
        console.log("homeChat watch nowChatList newVal = ", newVal);
        console.log(
          "homeChat watch nowChatList testTag = ",
          this.$store.state.authority.testTag
        );
        if (this.$store.state.authority.testTag === "1") {
          const obj = newVal[newVal.length - 1];
          if (obj.mine === false) {
            this.inputMsg = obj.text.text;
            this.bindEnter();
          }
        } else {
          if(this.$store.state.isScrollMsg){
            if (this.isScolTop) {
              console.log("scrolTop");
              this.isScolTop = false;
              this.scrolTop();
            } else {
              console.log("scrolBtm");
              this.scrolBtm();
            }
          }else{
            this.$store.state.isScrollMsg = true;
          }
        }
      },
      deep: true,
    },

    "selectedClient.trusteeship": function (newVal) {
      console.log("homeChat.vue selectedClient.trusteeship:", newVal);
      this.isCanEdit = newVal;
    },
    // nowChatList(newVal, oldVal) {
    //   // console.log('homeChat watch nowChatList newval = ', newVal)
    //   console.log("homeChat watch nowChatList oldval = ", oldVal);
    //   console.log(
    //     "homeChat watch nowChatList testTag = ",
    //     this.$store.state.authority.testTag
    //   );
    //   if (this.$store.state.authority.testTag === "1") {
    //     const obj = newVal[newVal.length - 1];
    //     if (obj.mine === false) {
    //       this.inputMsg = obj.text.text;
    //       this.bindEnter();
    //     }
    //   } else {
    //     if (this.isScolTop) {
    //       console.log("scrolTop");
    //       this.scrolTop();
    //     } else {
    //       console.log("scrolBtm");
    //       this.scrolBtm();
    //     }
    //   }
    // },

    troubleListLen(newLen, oldLen) {
      console.log("this.$store.state.troubleList.length", newLen, oldLen);
      this.getHistoryRequest(true);
    },
  },

  mounted() {
    console.log("homeChat mounted userInfo = ", this.userData);
    if (this.userData === null) {
      this.$store.state.selectedClient = null;
      this.$store.state.college.nowSelectClient = null;
      return;
    }
    this.getDetailRequest();
  },

  methods: {
    // 改变发送的值
    changeSendMessage(data) {
      console.log("改变发送的值");
      this.$emit("changeQuickReply", data);
    },
    getSendList(val) {
      this.getList = val;
    },

    getNameBySource(source) {
      var name = '其他'
      this.sourceList.forEach((e) => {
        if(e.value == source){
          name = e.label
        }
      });
      return name
    },

    handleGetFeedbackState(val) {
      this.getFeedback = val;
      console.log("this.getFeedback：", this.getFeedback);
    },
    handleGetFeedbackState2(val) {
      this.getFeedback = val;
      console.log("this.getFeedback2：", this.getFeedback);
    },
    getTrustVal(val) {
      console.log("homeChat getTrustVal val = ", val);
      this.isCanEdit = val;
    },

    getHistoryAction() {
      console.log(
        "this.currentPage < this.totalPage:",
        this.currentPage,
        this.totalPage
      );
      if (this.currentPage <= this.totalPage) {
        this.currentPage = this.currentPage + 1;
        this.isScolTop = true;
        this.getHistoryRequest(true);
      } else {
        this.$message({
          message: "暂无更多历史消息",
          type: "warning",
        });
      }
    },

    updateNickAction(name) {
      console.log("homeChat updateNickAction");
      this.isShowUpdate = true;
      this.inputNick = name;
    },

    async updateNickRequest() {
      if (this.inputNick.length === 0) {
        this.$message({
          message: "昵称不能为空",
          type: "warning",
        });

        return;
      }

      var csid = null;
      var selected = null;
      if (this.$store.state.colleageAngle) {
        console.log("updateNickRequest 我的同事");
        selected = this.$store.state.college.nowSelectClient;
        csid = this.$store.state.currentColleageInfo.id;
      } else {
        csid = this.util.getLocalId();
        selected = this.$store.state.selectedClient;
      }
      var api = "/manager/chat/customer/set/nickname";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          cid: selected.cid,
          nickname: this.inputNick,
          sid: selected.sid,
          csid: csid,
        },
      });

      console.log("homeChat updateNickRequest response = ", response);
      if (response.resultCode === "10000") {
        this.config.name = this.inputNick;
        this.isShowUpdate = false;

        if (this.$store.state.selectedKey === 4) {
          this.$store.state.college.nowSelectClient.nickname = this.inputNick;
          this.$store.state.college.nowSelectClient.isUpdateNike = 1;
        } else {
          this.$store.state.selectedClient.nickname = this.inputNick;
          this.$store.dispatch(
            "updateListNick",
            this.$store.state.selectedClient
          );
        }
      } else {
        this.$message.error(response.desc);
      }
    },

    updateMarkAction(mark) {
      this.isShowMark = true;
      this.inputMark = mark;
    },

    async updateMarkRequest() {
      var csid = null;
      var selected = null;
      if (this.$store.state.colleageAngle) {
        console.log("updateMarkRequest 我的同事");
        selected = this.$store.state.college.nowSelectClient;
        csid = this.$store.state.currentColleageInfo.id;
      } else {
        csid = this.util.getLocalId();
        selected = this.$store.state.selectedClient;
      }
      console.log("homeChat updateMarkRequest csid = ", csid);
      var api = "/manager/chat/customer/set/remark";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          cid: selected.cid,
          remark: this.inputMark,
          csid: csid,
          sid: selected.sid,
        },
      });

      console.log("homeChat updateNickRequest response = ", response);
      if (response.resultCode === "10000") {
        this.config.mark = this.inputMark;
        this.isShowMark = false;
      } else {
        this.$message.error(response.desc);
      }
    },

    updateMark(data) {
      this.inputMark = data;
      this.updateMarkRequest();
    },

    async getDetailRequest() {
      // console.log('homeChat getDetailRequest userData = ', this.userData)

      if (this.userData === null) {
        return;
      }
      let csid;
      if (this.$store.state.colleageAngle) {
        csid = this.$store.state.currentColleageInfo.id;
      } else {
        csid = this.util.getLocalId();
      }
      var api = "/manager/chat/customer/detail";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          cid: this.userData.cid,
          csid,
          sid: this.userData.sid,
        },
      });
      console.log("index getDetailRequest22 response = ", response);
      if (response.resultCode === "10000") {
        this.keyInfo = response.data;
        console.log("this.keyInfo ", this.keyInfo);
        var selected = null;
        console.log(
          "this.$store.state.selectedKey:",
          this.$store.state.selectedKey
        );
        console.log(
          " this.$store.state.college.nowSelectClient：",
          this.$store.state.college.nowSelectClient
        );
        console.log("this.selectedClient:", this.selectedClient);
        if (
          this.$store.state.colleageAngle &&
          this.$store.state.college.nowSelectClient !== null
        ) {
          console.log("response.data.cmcount：", response.data.cmcount);
          this.$store.state.college.nowSelectClient.cmcount =
            response.data.cmcount;
          this.$store.state.college.nowSelectClient.csmcount =
            response.data.csmcount;
          selected = this.$store.state.college.nowSelectClient;
        }
        selected = this.$store.state.selectedClient;
        console.log("this.selected:", this.selected);
        // this.config.name = response.data.customerNickname
        if (selected.isUpdateNike === 1) {
          this.config.name = selected.nickname;
        } else {
          if (
            this.util.changeGender(selected.gender) === "" &&
            this.util.nullToString(selected.age) === ""
          ) {
            this.config.name = selected.nickname;
          } else {
            this.config.name =
              this.util.changeGender(selected.gender) +
              this.util.changeAge(selected.age);
          }
        }
        if (selected.canOperate != false) {
          this.config.canOperate = true;
        } else {
          this.config.canOperate = false;
        }

        this.config.mark = response.data.customerRemark;
        let region = this.keyInfo.region;
        if (region !== null && region.length > 0) {
          this.config.ipdress = region;
        } else {
          this.config.ipdress = "";
        }
        this.config.number = this.keyInfo.sess_count;
        if (response.data.lastLabels !== null) {
          this.config.tags = response.data.lastLabels;
        }

        if (response.data.aduserId === "") {
          this.config.aduserId = "无";
        } else {
          this.config.aduserId = response.data.aduserId;
        }

        if (response.data.source === "") {
          this.config.source = "0";
        } else {
          this.config.source = response.data.source;
        }

        this.isCanEdit = response.data.trusteeship;
        // this.$refs.bottomBox.value1 = this.isCanEdit;
        // if (this.isCanEdit) {
        //     this.trustputRequest(response.data.sid)
        // }else{
        //   this.cancelTrustRequest(response.data.sid)
        // }
        this.$refs.enterBox.isDisable = !this.isCanEdit;
        console.log("homeChat getdetail iscanedit = ", this.isCanEdit);
        console.log("homeChat getdetail config = ", this.config);
        setTimeout(() => {
          var hei = "";
          // if ($(".key_container").css("display") == "flex") {
          //   hei = $(".key_container").height();
          // }
          if ($(".key_container1").css("display") == "flex") {
            hei = $(".key_container1").height();
          }
          if ($(".key_container2").css("display") == "flex") {
            hei = $(".key_container2").height();
          }
          var zhei = hei + 185;
          $(".taleBox").css("height", "calc(100% - " + zhei + "px)");
        }, 200);
        
        this.getHistoryRequest(false);
      } else {
        this.$message.error(response.desc);
      }
    },

    uploadImgAction(file) {
      const site = this.util.getLocalSite();
      const url = site.webUrl + "/manager/fileInfo/pass/upload";
      let param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据

      console.log("util update file = ", param.get("file")); // FormData私有类对象，访问不到，可以通过get判断值是否传进去
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      console.log("param------------------", param);
      // 添加请求头
      this.axios.post(url, param, config).then((res) => {
        console.log("util update res = ", res);
        if (res.data.resultCode === "10000") {
          const severUrl = this.util.getLocalImgUrl(); //'http://medibot.online/images' //online
          const imgUrl = severUrl + res.data.data.fileUrl;
          console.log("homeChat uploadImgAction imgUrl = ", imgUrl);
          var iType = "12";
          var client = this.$store.state.selectedClient;
          if (this.$store.state.colleageAngle) {
            iType = "9";
            client = this.$store.state.college.nowSelectClient;
          }

          const account = this.util.getLocalAccount();
          var avarUrl = require("../../static/talks/t_severbig.png");
          if (this.util.nullToString(account.logoUrl) !== "") {
            avarUrl = account.logoUrl;
          }

          var sendSeverObj = null;
          if (iType === "12") {
            sendSeverObj = {
              type: iType,
              timestamp: this.util.dateToTimestamp(new Date()),
              token: localStorage.getItem("token"),
              data: {
                msg: {
                  content: imgUrl,
                  timestamp: this.util.dateToTimestamp(new Date()),
                  imageUrl: imgUrl,
                  type: "image",
                  from: 1,
                },
                sess: {
                  cid: client.cid,
                  sid: client.sid,
                },
                cs_portrait: avarUrl,
                csname: account.realName,
              },
            };
          } else if (iType === "9") {
            sendSeverObj = {
              type: iType,
              timestamp: this.util.dateToTimestamp(new Date()),
              token: localStorage.getItem("token"),
              data: {
                msg: {
                  content: imgUrl,
                  timestamp: this.util.dateToTimestamp(new Date()),
                  imageUrl: imgUrl,
                  type: "image",
                  from: 1,
                },
                sess: {
                  cid: client.cid,
                  sid: client.sid,
                },
                csid: account.id,
                c_csid: client.csid,
                cs_portrait: avarUrl,
                csname: account.realName,
              },
            };
          }

          console.log("homeChat uploadImgAction sendSeverObj = ", sendSeverObj);
          this.$store.state.toServerChatObj = sendSeverObj;

          sendWebsocket(sendSeverObj, this.wsMessage, this.wsError);
          this.inputMsg = "";
          const chatscrol = this.$refs.chatlist;
          chatscrol.scrollBottom();
        } else {
          this.$confirm(res.data.desc, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: null,
            type: "warning",
            showCancelButton: false,
          }).then(() => {});
        }
      });
    },



    uploadVideoAction(file) {
      const site = this.util.getLocalSite();
      const url = site.webUrl + "/manager/fileInfo/pass/upload";
      let param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据

      console.log("util update file = ", param.get("file")); // FormData私有类对象，访问不到，可以通过get判断值是否传进去
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      console.log("param------------------", param);
      // 添加请求头
      this.axios.post(url, param, config).then((res) => {
        console.log("util update res = ", res);
        if (res.data.resultCode === "10000") {
          const severUrl = this.util.getLocalImgUrl(); //'http://medibot.online/images' //online
          const imgUrl = severUrl + res.data.data.fileUrl;
          console.log("homeChat uploadImgAction imgUrl = ", imgUrl);
          var iType = "12";
          var client = this.$store.state.selectedClient;
          if (this.$store.state.colleageAngle) {
            iType = "9";
            client = this.$store.state.college.nowSelectClient;
          }

          const account = this.util.getLocalAccount();
          var avarUrl = require("../../static/talks/t_severbig.png");
          if (this.util.nullToString(account.logoUrl) !== "") {
            avarUrl = account.logoUrl;
          }

          var sendSeverObj = null;
          if (iType === "12") {
            sendSeverObj = {
              type: iType,
              timestamp: this.util.dateToTimestamp(new Date()),
              token: localStorage.getItem("token"),
              data: {
                msg: {
                  content: imgUrl,
                  timestamp: this.util.dateToTimestamp(new Date()),
                  imageUrl: imgUrl,
                  type: "video",
                  from: 1,
                },
                sess: {
                  cid: client.cid,
                  sid: client.sid,
                },
                cs_portrait: avarUrl,
                csname: account.realName,
              },
            };
          } else if (iType === "9") {
            sendSeverObj = {
              type: iType,
              timestamp: this.util.dateToTimestamp(new Date()),
              token: localStorage.getItem("token"),
              data: {
                msg: {
                  content: imgUrl,
                  timestamp: this.util.dateToTimestamp(new Date()),
                  imageUrl: imgUrl,
                  type: "video",
                  from: 1,
                },
                sess: {
                  cid: client.cid,
                  sid: client.sid,
                },
                csid: account.id,
                c_csid: client.csid,
                cs_portrait: avarUrl,
                csname: account.realName,
              },
            };
          }

          console.log("homeChat uploadImgAction sendSeverObj = ", sendSeverObj);
          this.$store.state.toServerChatObj = sendSeverObj;

          sendWebsocket(sendSeverObj, this.wsMessage, this.wsError);
          this.inputMsg = "";
          const chatscrol = this.$refs.chatlist;
          chatscrol.scrollBottom();
        } else {
          this.$confirm(res.data.desc, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: null,
            type: "warning",
            showCancelButton: false,
          }).then(() => {});
        }
      });
    },

    clickEnter(obj) {
      console.log("homeChat clickEnter obj = ", obj);
      if (obj.split(" ").join("").length === 0) {
        return;
      }
      this.inputMsg = obj;
      this.bindEnter();
    },


    sendCard(msg) {
      console.log("homeChat sendCard msg = ", msg);
      this.$emit("changeQuickReply", "");
      if (!msg) {
        return;
      }
      var iType = "12";
      var client = this.$store.state.selectedClient;
      if (
        this.$store.state.colleageAngle &&
        this.$store.state.selectedPath >= 0
      ) {
        iType = "9";
        client = this.$store.state.college.nowSelectClient;
      }
      const account = this.util.getLocalAccount();

      var imgUrl = require("../../static/talks/t_severbig.png");
      if (this.util.nullToString(account.logoUrl) !== "") {
        imgUrl = account.logoUrl;
      }
      const txtMsg = this.replaceEmojiToBd(msg);
      if (iType === "12") {
        const sendSeverObj = {
          type: iType,
          timestamp: this.util.dateToTimestamp(new Date()),
          timestampStr:this.util.getFormatDate(0),
          token: localStorage.getItem("token"),
          data: {
            msg: {
              content: txtMsg,
              timestamp: this.util.dateToTimestamp(new Date()),
              type: "card",
              from: 1,
              text: msg,
            },
            sess: {
              cid: client.cid,
              sid: client.sid,
            },
            cs_portrait: imgUrl,
            csname: account.realName,
          },
        };
        this.$store.state.toServerChatObj = sendSeverObj;
        sendWebsocket(sendSeverObj, this.wsMessage, this.wsError);
        this.inputMsg = "";
        this.scrolBtm();
      } else if (iType === "9") {
        console.log(
          "homeChat bindEnter parent = ",
          this.$store.state.parentNode
        );
        const account = this.util.getLocalAccount();
        const client = this.$store.state.college.nowSelectClient;
        const sendSeverObj = {
          type: iType,
          timestamp: this.util.dateToTimestamp(new Date()),
          timestampStr:this.util.getFormatDate(0),
          token: localStorage.getItem("token"),
          data: {
            msg: {
              content: txtMsg,
              timestamp: this.util.dateToTimestamp(new Date()),
              type: "card",
              from: 1,
              text: msg,
            },
            sess: {
              cid: client.cid,
              sid: client.sid,
            },
            csid: account.id,
            c_csid: client.csid,
            cs_portrait: imgUrl,
            csname: account.realName,
          },
        };
        this.$store.state.toServerChatObj = sendSeverObj;
        sendWebsocket(sendSeverObj, this.wsMessage, this.wsError);
        this.scrolBtm();
      }
      this.isCanEdit = false;
      this.$refs.bottomBox.value1 = this.isCanEdit;
      this.$refs.enterBox.quickReplyItems = [];
      this.$refs.enterBox.showKey = false;
      this.$refs.enterBox.showBig = false;
    },

    bindEnter() {
      const msg = this.inputMsg;
      console.log("homeChat bindEnter msg = ", msg);
      this.$emit("changeQuickReply", "");
      // if (this.$store.state.colleageAngle) {
      //   this.$store.state.college.nowSelectClient.isFlicker = false;
      // } else {
      //   this.$store.state.selectedClient.isFlicker = false;
      // }
      if (!msg) {
        return;
      }

      if (msg.length > 1500) {
        this.$confirm("你输入的文本过长，无法发送", "消息过长", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          showCancelButton: false,
          showClose: false,
        });

        return;
      }

      console.log("homeChat bindEnter key = ", this.$store.state.selectedKey);
      console.log("homeChat bindEnter path = ", this.$store.state.selectedPath);

      var iType = "12";
      var client = this.$store.state.selectedClient;
      if (
        this.$store.state.colleageAngle &&
        this.$store.state.selectedPath >= 0
      ) {
        iType = "9";
        client = this.$store.state.college.nowSelectClient;
      }

      console.log("homechat bindenter client = ", client);

      const account = this.util.getLocalAccount();

      var imgUrl = require("../../static/talks/t_severbig.png");
      if (this.util.nullToString(account.logoUrl) !== "") {
        imgUrl = account.logoUrl;
      }

      const txtMsg = this.replaceEmojiToBd(msg);
      console.log("homeChat bindEnter txtMsg = ", txtMsg);
      if (iType === "12") {
        const sendSeverObj = {
          type: iType,
          timestamp: this.util.dateToTimestamp(new Date()),
          timestampStr:this.util.getFormatDate(0),
          token: localStorage.getItem("token"),
          data: {
            msg: {
              content: txtMsg,
              timestamp: this.util.dateToTimestamp(new Date()),
              type: "text",
              from: 1,
              text: msg,
            },
            sess: {
              cid: client.cid,
              sid: client.sid,
            },
            cs_portrait: imgUrl,
            csname: account.realName,
          },
        };
        console.log("homeChat bindEnter sendSeverObj = ", sendSeverObj);
        this.$store.state.toServerChatObj = sendSeverObj;
        sendWebsocket(sendSeverObj, this.wsMessage, this.wsError);
        this.inputMsg = "";
        this.scrolBtm();
      } else if (iType === "9") {
        console.log(
          "homeChat bindEnter parent = ",
          this.$store.state.parentNode
        );
        const account = this.util.getLocalAccount();
        const client = this.$store.state.college.nowSelectClient;
        const sendSeverObj = {
          type: iType,
          timestamp: this.util.dateToTimestamp(new Date()),
          timestampStr:this.util.getFormatDate(0),
          token: localStorage.getItem("token"),
          data: {
            msg: {
              content: txtMsg,
              timestamp: this.util.dateToTimestamp(new Date()),
              type: "text",
              from: 1,
              text: msg,
            },
            sess: {
              cid: client.cid,
              sid: client.sid,
            },
            csid: account.id,
            c_csid: client.csid,
            cs_portrait: imgUrl,
            csname: account.realName,
          },
        };
        console.log("homeChat bindEnter sendSeverObj = ", sendSeverObj);
        this.$store.state.toServerChatObj = sendSeverObj;
        sendWebsocket(sendSeverObj, this.wsMessage, this.wsError);
        this.inputMsg = "";
        this.scrolBtm();
      }
      this.isCanEdit = false;
      this.$refs.bottomBox.value1 = this.isCanEdit;
      this.$refs.enterBox.quickReplyItems = [];
      this.$refs.enterBox.showKey = false;
      this.$refs.enterBox.showBig = false;
    },

    scrolBtm() {
      console.log("这里吗")
      const chatscrol = this.$refs.chatlist;
      chatscrol.scrollBottom();
    },

    scrolTop() {
      const chatscrol = this.$refs.chatlist;
      chatscrol.scrollTop();
    },

    // ws连接成功，后台返回的ws数据，组件要拿数据渲染页面等操作
    wsMessage(data) {
      console.log("homeChat wsMessage");
      if (data === undefined) {
        return;
      }
    },

    // ws连接失败，组件要执行的代码
    wsError() {
      // 比如取消页面的loading
      console.log("homeChat wsError");
    },

    async getHistoryRequest(show) {
      console.log("homeChat getHistoryRequest page = ", this.currentPage);
      var api = "/manager/chat/record/list";
      var csid = this.util.getLocalId();
      console.log("this.$store.state.keyName :", this.$store.state.keyName);
      if (this.$store.state.colleageAngle) {
        console.log("getHistoryRequest 我的同事");
        // const selected = this.$store.state.college.nowSelectClient;
        csid = this.$store.state.currentColleageInfo.id;
      }
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          cid: this.userData.cid,
          csid: csid,
          // sid: this.userData.sid,
          page: this.currentPage,
          size: this.pageSize,
        },
      });
      console.log("index getHistoryRequest response = ", response);
      if (response.resultCode === "10000") {
        this.currentPage = response.data.current;
        this.totalPage = response.data.pages;
        // this.isShowHistory = false;
        if (this.currentPage === 1) {
          // if (this.totalPage > 1) {
          //   // this.isShowHistory = true;
          // } 
            this.isScolTop = false;
            this.$store.state.selectedChatList = null;
            this.toRecordList(response.data.list);
        } else {
          if (this.currentPage <= this.totalPage) {
            this.isScolTop = true;
            if(!show){
              this.isScolTop = false;
            }
            this.unshiftRecordList(response.data.list);
          } else {
            if(show){
              this.$message({
              message: "暂无更多历史消息",
              type: "warning",
            });
            }
          }
        }
      } else {
        this.$message.error(response.desc);
      }
    },

    unshiftRecordList(dataList) {
      console.log("homeChat unshiftRecordList isToTop = ", this.isScolTop);
      if (dataList === null) {
        return;
      }
      const reverseList = dataList.reverse();
      for (var i = 0; i < reverseList.length; i++) {
        let data = reverseList[i];
        var ismine = true;
        var name = "";
        //0:客户消息，1:客服消息，2:系统消息，3:同事代发消息 4-客户系统消息 5-客服系统消息
        var imgUrl = "";
        if (data.origin === 2) {
          name = data.csName;
          imgUrl = require("../../static/talks/t_robot.png");
        } else if (data.origin === 3 || data.origin === 1 || data.origin === 6) {
          name = data.csName;
          imgUrl = require("../../static/talks/t_severbig.png");
          if (this.util.nullToString(data.cs_portrait) !== "") {
            imgUrl = data.cs_portrait;
          }
        } else {
          if (data.origin === 0) {
            ismine = false;
            name = this.userData.nickname;
          } else {
            //4,5系统消息
            ismine = false;
          }
        }
        //0-客服或客户发的消息 1-系统提醒消息
        var itype = "0";
        if (data.origin === 4 || data.origin === 5) {
          itype = "1";
        }

        var iColor = "0"; //0-正常的聊天信息 1-单消息 2-多消息
        if (data.msgExts !== null) {
          if (data.msgExts.length === 1) {
            iColor = "1";
          } else if (data.msgExts.length > 1) {
            iColor = "2";
          }
        }

        if (data.type === "text") {
          const textObj = {
            date: this.util.timeStampToDate(data.timestamp * 1000, 1),
            text: {
              text: data.content,
              type: data.type,
            },
            mine: ismine,
            name: name,
            avar: imgUrl,
            type: itype,
            color: iColor,
            id: data.id,
            isChecked: "0",
            sendStatus: data.sendStatus,
            status: data.status,
            // origin: data.origin,
          };

          this.$store.state.selectedChatList.unshift(textObj);
          console.log("添加图片----------------text");
        } else if (data.type === "image") {
          let imgText = "<img data-src=" + data.content + ">";
          const imgObj = {
            date: this.util.timeStampToDate(data.timestamp * 1000, 1),
            text: {
              text: imgText,
              type: data.type,
            },
            mine: ismine,
            name: name,
            avar: imgUrl,
            type: itype,
            color: iColor,
            id: data.id,
            isChecked: "0",
            sendStatus: data.sendStatus,
            status: data.status,
            // origin: data.origin,
          };

          this.$store.state.selectedChatList.unshift(imgObj);
          console.log("添加图片----------------image");
        } else if (data.type === "video") {
          let videoText = "<video data-src=" + data.content + ">";
          const videoObj = {
            date: this.util.timeStampToDate(data.timestamp * 1000, 1),
            text: {
              text: videoText,
              type: data.type,
            },
            mine: ismine,
            name: name,
            avar: imgUrl,
            type: itype,
            color: iColor,
            id: data.id,
            isChecked: "0",
            sendStatus: data.sendStatus,
            status: data.status,
            // origin: data.origin,
          };

          this.$store.state.selectedChatList.unshift(videoObj);
          console.log("添加视频----------------video");
        } else if (data.type === "audio") {
          let audioText = "<audio data-src=" + data.content + ">";
          const audioObj = {
            date: this.util.timeStampToDate(data.timestamp * 1000, 1),
            text: {
              text: audioText,
              type: data.type,
            },
            mine: ismine,
            name: name,
            avar: imgUrl,
            type: itype,
            color: iColor,
            id: data.id,
            isChecked: "0",
            sendStatus: data.sendStatus,
            status: data.status,
            // origin: data.origin,
          };

          this.$store.state.selectedChatList.unshift(audioObj);
          console.log("添加语音----------------audio");
        } else if (data.type === "card") {
          const textObj = {
            date: this.util.timeStampToDate(data.timestamp * 1000, 0),
            text: {
              text: "已经发送留资卡",
              type: data.type,
            },
            mine: false,
            name: name,
            avar: imgUrl,
            type: '1',
            color: iColor,
            id: data.id,
            isChecked: "0",
            sendStatus: data.sendStatus,
            status: data.status,
            // origin: data.origin,
          };

          this.$store.state.selectedChatList.unshift(textObj);
        } 
      }
      this.scrolTop();
    },

    toRecordList(dataList) {
      console.log("homeChat toRecordList isToTop = ", this.isScolTop);
      if (dataList === null) {
        return;
      }
      if (this.$store.state.selectedChatList === null) {
        this.$store.state.selectedChatList = [];
      }
      for (var i = 0; i < dataList.length; i++) {
        // console.log("homeChat.vue toReordList data:", dataList[i]);
        let data = dataList[i];
        var ismine = true;
        var name = "";

        //0:客户消息，1:客服消息，2:系统消息，3:同事代发消息 4-客户系统消息 5-客服系统消息
        var imgUrl = "";
        if (data.origin === 2) {
          name = data.csName;
          imgUrl = require("../../static/talks/t_robot.png");
        } else if (data.origin === 3 || data.origin === 1 || data.origin === 6) {
          name = data.csName;
          imgUrl = require("../../static/talks/t_severbig.png");
          if (this.util.nullToString(data.cs_portrait) !== "") {
            imgUrl = data.cs_portrait;
          }
        } else {
          if (data.origin === 0) {
            ismine = false;
            name = this.userData.nickname;
          } else {
            //4,5系统消息
            ismine = false;
          }
        }

        //0-客服或客户发的消息 1-系统提醒消息
        var itype = "0";
        if (data.origin === 4 || data.origin === 5) {
          itype = "1";
        }

        var iColor = "0"; //0-正常的聊天信息 1-单消息 2-多消息
        if (data.msgExts !== null) {
          if (data.msgExts.length === 1) {
            iColor = "1";
          } else if (data.msgExts.length > 1) {
            iColor = "2";
          }
        }

        if (data.type === "text") {
          const textObj = {
            date: this.util.timeStampToDate(data.timestamp * 1000, 0),
            text: {
              text: this.util.replaceBdToEmoji(data.content),
              type: data.type,
            },
            mine: ismine,
            name: name,
            avar: imgUrl,
            type: itype,
            color: iColor,
            id: data.id,
            isChecked: "0",
            sendStatus: data.sendStatus,
            status:data.status
            // origin: data.origin,
          };
          this.$store.state.selectedChatList.push(textObj);
          console.log("添加图片----------------text");
        } else if (data.type === "image") {
          let imgText = "<img data-src=" + data.content + ">";
          const imgObj = {
            date: this.util.timeStampToDate(data.timestamp * 1000, 0),
            text: {
              text: imgText,
              type: data.type,
            },
            mine: ismine,
            name: name,
            avar: imgUrl,
            type: itype,
            color: iColor,
            id: data.id,
            isChecked: "0",
            sendStatus: data.sendStatus,
            status:data.status
            // origin: data.origin,
          };
          this.$store.state.selectedChatList.push(imgObj);
          console.log("添加图片----------------image");
        } else if (data.type === "video") {
          let videoText = "<video data-src=" + data.content + ">";
          const videoObj = {
            date: this.util.timeStampToDate(data.timestamp * 1000, 0),
            text: {
              text: videoText,
              type: data.type,
            },
            mine: ismine,
            name: name,
            avar: imgUrl,
            type: itype,
            color: iColor,
            id: data.id,
            isChecked: "0",
            sendStatus: data.sendStatus,
            status: data.status,
            // origin: data.origin,
          };
          this.$store.state.selectedChatList.push(videoObj);
          console.log("添加视频----------------video");
        } else if (data.type === "audio") {
          let audioText = "<audio data-src=" + data.content + ">";
          const audioObj = {
            date: this.util.timeStampToDate(data.timestamp * 1000, 0),
            text: {
              text: audioText,
              type: data.type,
            },
            mine: ismine,
            name: name,
            avar: imgUrl,
            type: itype,
            color: iColor,
            id: data.id,
            isChecked: "0",
            sendStatus: data.sendStatus,
            status: data.status,
            // origin: data.origin,
          };
          this.$store.state.selectedChatList.push(audioObj);
          console.log("添加语音----------------audio");
        } else if (data.type === "card") {
          const textObj = {
            date: this.util.timeStampToDate(data.timestamp * 1000, 0),
            text: {
              text: "已经发送留资卡",
              type: data.type,
            },
            mine: false,
            name: name,
            avar: imgUrl,
            type: '1',
            color: iColor,
            id: data.id,
            isChecked: "0",
            sendStatus: data.sendStatus,
            status:data.status
            // origin: data.origin,
          };
          this.$store.state.selectedChatList.push(textObj);
        }
      }
    },

    loadHistoryHandler() {
      const { historyConfig: { callback = null } = {} } = this.chatListConfig;
      callback && callback();
    },

    bindEmoji(emoji) {
      this.inputMsg += emoji;
    },

    bindAddTag(obj) {
      console.log("homeChat bindAddTag obj = ", obj);
      this.isAddTag = true;
      this.selectedTagList = obj;

      if (this.isAddTag === true) {
        this.getAllTagsRequest();
      }
    },

    setAdapterAction(isAdapter) {
      console.log("homeChat setAdapterAction isAdapter = ", isAdapter);
      this.isSetAdapter = isAdapter;
      this.$emit("setAdapter2", this.isSetAdapter);
    },

    async getAllTagsRequest() {
      this.usedTagList = [];
      this.allTagList = [];
      console.log("UserItem getTagsRequest");
      var api = "/manager/labelLnUser/settingSwitchAll";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          cid: this.userData.cid,
        },
      });
      console.log("index getAllTagsRequest response = ", response);
      if (response.data !== null) {
        for (var i = 0; i < response.data.labelVoFiveList.length; i++) {
          var used = response.data.labelVoFiveList[i];
          used.selected = false;
          for (var k = 0; k < this.selectedTagList.length; k++) {
            var selectedObj = this.selectedTagList[k];
            if (used.id === selectedObj.id) {
              used.selected = true;
            }
          }

          this.usedTagList.push(used);
        }

        for (var j = 0; j < response.data.labelVoAllList.length; j++) {
          var tag = response.data.labelVoAllList[j];
          tag.selected = false;
          for (var m = 0; m < this.selectedTagList.length; m++) {
            var selectedObj1 = this.selectedTagList[m];
            if (tag.id === selectedObj1.id) {
              tag.selected = true;
            }
          }
          this.allTagList.push(tag);
        }
      }
    },

    bindLoadHistory() {
      const history = new Array(3).fill().map((i, j) => {
        return {
          date: "2020/05/20 23:19:07",
          text: {
            text: j + new Date(),
          },
          mine: false,
          name: "JwChat",
          img: "image/three.jpeg",
        };
      });
      let list = history.concat(this.list);
      this.list = list;
      console.log("加载历史", list, history);
    },

    change() {
      this.num++;
    },

    talkEvent(play) {
      console.log("homechat talkEvent play = ", play);
      console.log(play);
    },

    bindCover(type) {
      console.log("homechat bindCover type = ", type);
    },

    showMoreClick() {
      this.isShowMore = !this.isShowMore;
    },

    //点击结束会话按钮
    clickEnd(isEnd) {
      console.log("homeChat clickEnd isEnd = ", isEnd);
      // var client = this.$store.state.selectedClient
      // if (this.$store.state.selectedKey === 4) {
      // 	client = this.$store.state.college.nowSelectClient
      // }

      var csid = null;
      var selected = null;
      if (this.$store.state.colleageAngle) {
        csid = this.$store.state.currentColleageInfo.id;
        selected = this.$store.state.college.nowSelectClient;
      } else {
        csid = this.util.getLocalId();
        selected = this.$store.state.selectedClient;
      }

      const endSeverObj = {
        type: "14",
        timestamp: this.util.dateToTimestamp(new Date()),
        token: localStorage.getItem("token"),
        data: {
          sess: {
            cid: selected.cid,
            sid: selected.sid,
          },
          csid: csid,
        },
      };
      sendWebsocket(endSeverObj, this.wsMessage, this.wsError);
    },

    chooseTag(section, index) {
      console.log("homeChat chooseTag section = ", section);
      console.log("homeChat chooseTag index = ", index);
      let isChecked = null;
      if (section === 0) {
        const usedTag0 = this.usedTagList[index];
        for (var i = 0; i < this.allTagList.length; i++) {
          var allTag0 = this.allTagList[i];
          if (usedTag0.id === allTag0.id) {
            allTag0.selected = !allTag0.selected;
          }
        }

        usedTag0.selected = !usedTag0.selected;
        // 其他标签选中则取消暂无
        isChecked = this.usedTagList.some((item) => {
          return item.id !== "zanwu" && item.selected === true;
        });
      } else {
        const allTag1 = this.allTagList[index];
        for (var j = 0; j < this.usedTagList.length; j++) {
          var usedTag1 = this.usedTagList[j];
          if (usedTag1.id === allTag1.id) {
            usedTag1.selected = !usedTag1.selected;
          }
        }
        allTag1.selected = !allTag1.selected;
        // 其他标签选中则取消暂无
        isChecked = this.allTagList.some((item) => {
          return item.id !== "zanwu" && item.selected === true;
        });
      }

      // 获取在所有标签中 暂无标签的下标
      zanwu(this.allTagList);
      zanwu(this.usedTagList);
      function zanwu(arr) {
        const z_index = arr.findIndex((item) => {
          return item.id === "zanwu";
        });
        console.log("homeChat chooseTag z_index = ", z_index);
        if (z_index !== -1) {
          if (isChecked) {
            arr[z_index].selected = false;
          } else {
            arr[z_index].selected = true;
          }
        }
        console.log("homeChat chooseTag isChecked = ", isChecked);
        console.log("homeChat chooseTag arr = ", arr);
      }

      // if (tag.selected === null) {
      // 	tag.selected = true
      // }
      // tag.selected = !tag.selected
    },

    setTagAction() {
      console.log("homeChat setTagAction111");
      this.isAddTag = false;

      var selected = null;
      if (this.$store.state.colleageAngle) {
        console.log("setTagRequest 我的同事");
        selected = this.$store.state.college.nowSelectClient;
      } else {
        selected = this.$store.state.selectedClient;
      }

      console.log("client = ", selected);

      var lnUsers = [];
      var tags = [];
      for (var i = 0; i < this.usedTagList.length; i++) {
        const used = this.usedTagList[i];
        if (used.selected === true) {
          const obj = {
            userId: selected.cid,
            lableId: used.id,
          };
          lnUsers.push(obj);
          tags.push(used);
        }
      }

      for (var j = 0; j < this.allTagList.length; j++) {
        const tag = this.allTagList[j];
        if (tag.selected === true) {
          const obj = {
            userId: selected.cid,
            lableId: tag.id,
          };
          lnUsers.push(obj);
          tags.push(tag);
        }
      }

      console.log("setTag lnusers = ", lnUsers);

      let arr1 = this.unique1(lnUsers);
      let arr2 = this.unique2(tags);

      this.setTagRequest(arr1, arr2);
    },

    unique1(arr) {
      const res = new Map();
      return arr.filter(
        (arr) => !res.has(arr.lableId) && res.set(arr.lableId, 1)
      );
    },

    unique2(arr) {
      const res = new Map();
      return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1));
    },

    async setTagRequest(users, tagList) {
      console.log("homeChat setTagRequest users = ", users);
      console.log("homeChat setTagRequest tagList = ", tagList);
      let labelLnUsers = [];
      // 配合后端取消为空时，传参为暂无
      if (users.length === 0) {
        labelLnUsers = {
          userId: JSON.parse(localStorage.getItem("account")).id,
          lableId: "zanwu",
        };
      } else {
        labelLnUsers = users;
      }
      var api = "/manager/labelLnUser/saveList";

      var csid = null;
      var selected = null;
      if (this.$store.state.colleageAngle) {
        console.log("setTagRequest 我的同事");
        selected = this.$store.state.college.nowSelectClient;
        csid = this.$store.state.currentColleageInfo.id;
      } else {
        csid = this.util.getLocalId();
        selected = this.$store.state.selectedClient;
      }

      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          labelLnUsers,
          cid: selected.cid,
          sid: selected.sid,
          csid: csid,
        },
      });
      console.log("homeChat setTagRequest response = ", response);
      console.log("homeChat tagList00 = ", tagList);
      if (response.resultCode === "10000") {
        this.config.tags = [];
        this.config.tags = tagList;
        let isWX = false;
        if (tagList != []) {
          for (let i = 0; i < tagList.length; i++) {
            if (
              tagList[i].id == "zhuanwei" ||
              tagList[i].id == "zhuandian" ||
              tagList[i].id == "yuyue" ||
              tagList[i].id == "weiyuyue" ||
              tagList[i].id == "zhuanqq"
            ) {
              isWX = true;
            }

            var tagObj = tagList[i];
            tagObj.level = 0;
            if (
              tagObj.id === "zhuanwei" ||
              tagObj.id === "zhuandian" ||
              tagObj.id === "zhuanqq"
            ) {
              tagObj.level = 2;
            } else if (tagList[i].id == "weiyuyue") {
              tagObj.level = 3;
            } else if (tagList[i].id == "yuyue") {
              tagObj.level = 4;
            }
          }

          tagList = tagList.sort(function (a, b) {
            return b.level - a.level;
          });
          console.log("homeChat tagList22 = ", tagList);
          const first = tagList[0];
          console.log("homeChat tagList22 first = ", first);
          if (first !== undefined) {
            if (this.$store.state.keyName !== "我的同事") {
              if (isWX == true) {
                this.$store.dispatch("upTalkingStatus", first.level);
              } else {
                this.$store.dispatch("upTalkingStatus", "1");
              }
            } else {
              if (isWX === true) {
                this.$store.state.college.nowSelectClient.status = first.level;
              }
            }
          } else {
            if (this.$store.state.keyName !== "我的同事") {
              this.$store.state.selectedClient.status = 1;
            } else {
              this.$store.state.college.nowSelectClient.status = 1;
            }
          }
        } else {
          if (this.$store.state.selectedKey === 4) {
            this.$store.state.college.nowSelectClient.status = 1;
          } else {
            this.$store.state.selectedClient.status = 1;
          }
        }
      } else {
        this.$message.error(response.desc);
      }
    },

    cancelTranster(obj) {
      console.log("homeChat cancelTranster obj = ", obj);
      this.isShowTranster = obj;
    },

    clickIntrerpret(obj) {
      //true-客服转接 false-我的同事转接Ta
      console.log("homeChat clickIntrerpret obj =", obj);
      console.log(
        "homChat store nowSelectClient：",
        this.$store.state.college.nowSelectClient
      );
      // if (obj === true) {
      //   this.transterType = "0";
      // } else {
      //   this.transterType = "2";
      // }
      console.log(
        "homChat store colleageAngle",
        this.$store.state.colleageAngle
      );
      if (this.$store.state.colleageAngle) {
        this.transterType = "2";
        this.getcollegesRequest();
      } else {
        this.transterType = "0";
        this.getOnLineUser();
      }
      // this.getcollegesRequest();
    },

    async getOnLineUser() {
      // var api = "/manager/chat/online/cs/list";
      var api = "/manager/chat/colleague/online/cs/list";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      console.log("index getOnLineUser response = ", response);
      if (response.data.length === 0) {
        this.isShowTranster = false;
        this.$confirm("没有在线客服可供选择，暂无法转接！", "提示", {
          confirmButtonText: "确定",
          showClose: false,
          showCancelButton: false,
          type: "warning",
        });

        return;
      } else {
        this.isShowTranster = true;
        this.customList = [];
        let dataList = response.data;
        for (var i = 0; i < dataList.length; i++) {
          var custom = dataList[i];
          custom.selected = false;
          //1-在线 2-忙碌 0-离开
          if (custom.status === 1) {
            custom.state = "在线";
          } else if (custom.status === 2) {
            custom.state = "忙碌";
          } else if (custom.status === 0) {
            custom.state = "离开";
          }
          this.customList.push(custom);
        }
      }
      console.log(" this.isShowTranster  = ", this.isShowTranster);
    },

    async getcollegesRequest() {
      console.log(
        "homeChat getcollegesRequest  currentColleageInfo",
        this.$store.state.currentColleageInfo
      );
      var api = "/manager/chat/colleague/online/cs/list";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          c_csid: this.$store.state.currentColleageInfo.id,
        },
      });
      console.log("index getcollegesRequest response = ", response);
      if (response.data.length === 0) {
        this.isShowTranster = false;
        this.$confirm("没有在线客服可供选择，暂无法转接个他人！", "提示", {
          confirmButtonText: "确定",
          showClose: false,
          showCancelButton: false,
          type: "warning",
        });

        return;
      } else {
        this.isShowTranster = true;
        this.customList = [];
        let dataList = response.data;
        const account = this.util.getLocalAccount();
        for (var i = 0; i < dataList.length; i++) {
          var custom = dataList[i];
          custom.selected = false;
          //1-在线 2-忙碌 0-离开
          if (custom.status === 1) {
            custom.state = "在线";
          } else if (custom.status === 2) {
            custom.state = "忙碌";
          } else if (custom.status === 0) {
            custom.state = "离开";
          }

          if (custom.csid === account.id) {
            custom.name = "自己";
          }

          this.customList.push(custom);
        }
      }
    },

    async setTranster(isShow, obj) {
      console.log("homeChat setTranster obj csid = ", obj);
      console.log("homeChat setTranster obj isShow = ", isShow);
      console.log("homeChat setTranster obj type = ", this.transterType);
      this.isShowTranster = isShow;
      if (this.transterType === "0") {
        this.transterRequest(obj);
      } else if (this.transterType === "2") {
        this.transterTaRequest(obj);
      }
    },
    async transterRequest(obj) {
      const selected = this.$store.state.selectedClient;
      const account = this.util.getLocalAccount();
      var api = "/manager/session/transfer";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          csid: account.id,
          t_csid: obj.csid,
          sid: selected.sid,
        },
      });
      console.log("homeChat setTranster response = ", response);
      if (response.resultCode === "10000") {
        const selectedObj = this.$store.state.selectedClient;
        console.log("homeChat setTranster selectedObj = ", selectedObj);
        console.log(
          "this.$store.state.selectedKey ",
          this.$store.state.selectedKey
        );
        if (this.$store.state.selectedKey === 1) {
          this.$store.commit("spliceTalkObj", selectedObj);
        } else if (this.$store.state.selectedKey === 2) {
          this.$store.commit("spliceBrowerObj", selectedObj);
        } else if (this.$store.state.selectedKey === 3) {
          this.$store.commit("spliceLeaveObj", selectedObj);
        }
        this.isShowTranster = false;
        this.$store.state.selectedClient = null;
        this.$store.state.college.nowSelectClient = null;
      } else {
        this.$message.error(response.desc);
      }
    },

    async transterTaRequest(obj) {
      const selected = this.$store.state.college.nowSelectClient;
      const account = this.util.getLocalAccount();
      console.log("homeChat transterTaRequest selected = ", selected);

      var api = "/manager/session/colleague/transfer";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          csid: account.id,
          c_csid: this.$store.state.currentColleageInfo.id,
          t_csid: obj.csid,
          sid: selected.sid,
        },
      });
      console.log("homeChat transterTaRequest response = ", response);
      if (response.resultCode === "10000") {
        // const selectedObj = this.$store.state.nowSelectClient;
        console.log("homeChat setTranster selectedObj = ", selected);
        if (this.$store.state.selectedKey === 1) {
          this.$store.commit("spliceTalkObj", selected);
        }
        this.isShowTranster = false;
        this.$store.state.selectedClient = null;
        this.$store.state.college.nowSelectClient = null;
      } else {
        this.$message.error(response.desc);
      }
    },

    replaceEmojiToBd(txtContent) {
      console.log("homeChat replaceEmojiToBd txtContent = ", txtContent);

      var toRe1 = "/::)";
      txtContent = txtContent.replace(toRe1, "[微笑]");

      var toRe2 = "/::P";
      txtContent = txtContent.replace(toRe2, "[调皮]");

      var toRe3 = "/::B";
      txtContent = txtContent.replace(toRe3, "[色]");

      var toRe4 = "/::Z";
      txtContent = txtContent.replace(toRe4, "[睡]");

      var toRe5 = "/:?";
      txtContent = txtContent.replace(toRe5, "[疑问]");

      var toRe6 = "/::<";
      txtContent = txtContent.replace(toRe6, "[流泪]");

      var toRe7 = "/::L";
      txtContent = txtContent.replace(toRe7, "[汗]");

      var toRe8 = "/:,@@";
      txtContent = txtContent.replace(toRe8, "[晕]");

      var toRe9 = "/::~";
      txtContent = txtContent.replace(toRe9, "[撇嘴]");

      var toRe10 = "/::!";
      txtContent = txtContent.replace(toRe10, "[惊恐]");

      var toRe11 = "/::-|";
      txtContent = txtContent.replace(toRe11, "[尴尬]");

      var toRe12 = "/::$";
      txtContent = txtContent.replace(toRe12, "[害羞]");

      var toRe13 = "/:P-(";
      txtContent = txtContent.replace(toRe13, "[委屈]");

      var toRe14 = "/::D";
      txtContent = txtContent.replace(toRe14, "[大笑]");

      var toRe15 = "/::'(";
      txtContent = txtContent.replace(toRe15, "[大哭]");

      var toRe16 = "/:,@-D";
      txtContent = txtContent.replace(toRe16, "[可爱]");

      var toRe17 = "/:bye";
      txtContent = txtContent.replace(toRe17, "[再见]");

      var toRe18 = "/:,@P";
      txtContent = txtContent.replace(toRe18, "[偷笑]");

      var toRe19 = "/:X-)";
      txtContent = txtContent.replace(toRe19, "[乖]");

      var toRe20 = "/::(";
      txtContent = txtContent.replace(toRe20, "[难过]");

      return txtContent;
    },
    // 复制当前浏览url
    copyText(text,type) {
      this.$store.state.copyText = text;
      if(type == 0){
        this.$message.success("复制链接成功");
      }else if(type == 1){
        this.$message.success("复制关键字成功");
      }else if(type == 2){
        this.$message.success("复制永久编号成功");
      }else{
        this.$message.success("复制搜索词成功");
      }
      
      this.$copyText(text).then(
        function (e) {
          console.log(e);
        },
        function (e) {
          console.log(e);
        }
      );
    },

    // // 显示当前浏览url的完整地址
    // hoverShow() {
    //   this.urlAllShow = true;
    // },
    // // 不显示当前浏览url的完整地址
    // hoverNotShow() {
    //   this.urlAllShow = false;
    // },
  },
};
</script>

<style scoped="scoped" lang="scss">
.chat_container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  /* background-color: red; */
}

.ChatPage {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  /* background-color: bisque; */
}

.header {
  height: 100px;
  width: 100%;
  display: flex;
  /* justify-content: flex-start; */
  align-items: center;
  /* background-color: gold; */
}

.chatBox {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding-top: 8px;
  box-sizing: border-box;
  /* display: none; */
  /* height: calc(100vh-116px); */
  /* align-items: center; */
  background-color: #eaf5eb;
}

.taleBox {
  // height: calc(100% - 250px);
  flex: 1;
  overflow: hidden;
  width: 100%;

  background-color: #eaf5eb;
  /* margin-bottom: 0.625rem; */
}

.taleBox::-webkit-scrollbar {
  display: none;
}

.toolBox {
  display: flex;
  flex-direction: column;
  // height: 200px;
  position: relative;
  /* padding-bottom: 0; */
  background-color: #e2e8f0;
  /* display: none; */
}

.bottomBox {
  width: 100%;
  // position: absolute;
  // bottom: 0;
}

.header_line {
  width: 100%;
  height: 4px;
  background-color: #e2e8f0;
  // background-color: #FFFFFF;
  z-index: 1;
}

.key_container {
  @include change_tip_size($tip_size_normal);
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 4px;
}

.query_div {
  /* background-color: cyan; */
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-top: 0.5rem;
}

.query_lb {
  width: 90%;
  @include change_tip_size($tip_size_normal);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  /* background-color: blueviolet; */
  text-align: left;
  padding-left: 1.25rem;
  display: flex;
  align-items: center;
}

.key_lb {
  width: 90%;
  @include change_tip_size($tip_size_normal);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  text-align: left;
  //padding-left: 1.25rem;
  white-space: nowrap;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  /* padding-top: 1rem; */
}

.key_div {
  width: 100%;
  /* height: 4.375rem; */
  background-color: rgba(254, 164, 127, 0);
  border-radius: 4px;
  /* margin-top: 0.625rem; */
}

.keyword {
  //width: 100%;
  /* height: 2.0625rem; */
  //display: flex;
 //flex-direction: row;
 // justify-content: space-between;
 // align-items: center;
  /* background-color: yellow; */

  @include change_tip_size($tip_size_normal);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  /* margin-left: 0.625rem; */
  padding-left: 1.25rem;
  white-space: nowrap;
  cursor: pointer;
  display: flex;
  width: 50%;
  align-items: center;
  justify-content: space-between;
}

.otherInfo {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 0.5rem;
  margin-top: 0.3rem;
}

.key_container1 {
  @include change_tip_size($tip_size_normal);
  width: 90%;
  max-height: 90px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 4px;
}

.key_div1 {
  width: 90%;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
}

.key_div1_1 {
  margin: 0.5rem 0;
  overflow: hidden;
}

.keyword1 {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background-color: rgba(37, 204, 247, 0);
}

.brow_lb1 {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  padding-left: 1.25rem;
  white-space: nowrap;
}

.site_lb1 {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  /* margin-left: 1.875rem; */
  margin-left: 1.5rem;
  padding-right: 1.25rem;
  white-space: nowrap;
}

.key_lb1 {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  text-align: left;
  padding-left: 1.25rem;
}

.query_div1 {
  width: 90%;
  display: flex;
  justify-content: flex-start;
  margin-top: 0.5rem;
}

.query_lb1 {
  width: 100%;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  text-align: left;
  padding-left: 1.25rem;
}
.searchText {
  @include change_title_size(title_size_normal);
  color: #de4f4f;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
}

.key_container2 {
  @include change_tip_size($tip_size_normal);
  width: 90%;
  max-height: 90px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 4px;
}

.key_div2 {
  margin-top: 0.5rem;
  background-color: rgba(254, 164, 127, 0);
}

.history_div {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  //margin-bottom: 0.5rem;
  height: 35px;
}

.history_lb {
  @include change_tip_size($tip_size_normal);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  margin-left: 0.5rem;
  cursor: pointer;
}

.brow_lb {
  @include change_tip_size($tip_size_normal);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  /* margin-left: 0.625rem; */
  padding-left: 1.25rem;
  white-space: nowrap;
  cursor: pointer;
  display: flex;
  width: 50%;
  align-items: center;
  /* background-color: yellow; */
}

.url_lb {
  display: inline-block;
  max-width: 100%;
  @include change_tip_size($tip_size_normal);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  text-decoration: underline;
  text-decoration-color: rgba(0, 0, 0, 0.65);
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  white-space: nowrap;
}
.url-allShow {
  @include change_tip_size($tip_size_normal);
  display: flex;
  flex-direction: column;
  & > span:nth-of-type(1)::after {
    display: block;
    content: "";
    width: 100px;
    margin: 4px 0;
    border-top: 1px solid #ccc;
  }
}
.url-copy {
  cursor: pointer;
  color: #1677d2;
}
.site_lb {
  @include change_tip_size($tip_size_normal);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  padding-right: 1.25rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.keyword2 {
  width: 100%;
  /* height: 2.0625rem; */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  /* padding-top: 1rem;
		padding-bottom: 1rem; */
}

.brow_lb2 {
  @include change_tip_size($tip_size_normal);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  /* margin-left: 0.625rem; */
  text-align: center;
  padding-left: 1.25rem;
  /* padding-right: 1.25rem; */
  white-space: nowrap;
}

.site_lb2 {
  @include change_tip_size($tip_size_normal);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  /* margin-left: 1.875rem; */
  text-align: center;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  white-space: nowrap;
}

.key_lb2 {
  @include change_tip_size($tip_size_normal);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  text-align: center;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.common_div,
.all_div {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 95%;
  height: 30%;
  padding: 10px;
}

.all_div {
  margin-top: 20px;
}

.tag_lb {
  @include change_tip_size($tip_size_normal);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(68, 68, 68, 0.8);
  margin-bottom: 15px;
}

.tag_box {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
}

.tag_btn,
.tag_selected {
  margin-bottom: 0.625rem;
  line-height: 1.25rem;
  padding: 0.3125rem 0.625rem;
  background: #f4f7fb;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  margin-left: 0.625rem;
  @include change_size($font_size_normal);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(68, 68, 68, 0.5);
}

.tag_selected {
  background-color: #ffffff;
}

.dialog-footer {
  /* background: orange; */
  display: flex;
  justify-content: center;
}
</style>
